import styles from './Footer.module.scss';
import { ReactComponent as LogoFooterSVG } from '../../../assets/logo-footer.svg';

export const Footer = () => {
    return (
        <div className={styles.container}>
            <div className={styles.backgroundTop}></div>
            <div className={styles.wrap}>
                <div className={styles.column}>
                    <LogoFooterSVG />
                    <div className={styles.copyright}>© Copyright 2022 Snatch B.V.</div>
                    <div className={styles.text}>All right reserved</div>
                </div>

                <div className={styles.row}>
                    <a href="src/components/Shared/Footer/Footer#" className={styles.href}>
                        Terms of Use
                    </a>
                    <a href="src/components/Shared/Footer/Footer#" className={styles.href}>
                        Privacy Policy
                    </a>
                </div>
                <div className={styles.column}>
                    <div className={styles.copyright}>Developing with 💜</div>
                    <div className={styles.text}>Overschiestraat 59, 1062XD Amsterdam</div>
                </div>
            </div>
        </div>
    );
};
